module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAxklEQVQoU5XPMUoDURAG4G9A4gliadA2laD2egK7XMEjiJ1pbETsLIRcwQOIXkAQbLYNNiKClUUgICMbfBJ00d1pHsz7P2YmNFRmjnCBFRxHxNVyLH6azFzDM07wjnNsRMRTyTahAaZYxwwv2I6Ix18oM3dwhlXs4g0fqCffY45xRNx8T8rMW+w33bjUqyJiuECZ2fvav37/qkS/oD3c/QPK96igUxy1RJOCHrDVEk0jM/t4bQkWsRod4LorusRhV1Rhswv6BPtyQ88+GF6/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/goodsWeight.png
// module id = oaNX
// module chunks = 2